var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-runtime-shell',{staticClass:"content-container",attrs:{"student-type":_vm.getStudentType(),"template":_vm.content.html,"application-base-url":_vm.applicationBaseUrl,"i18n":_vm.$root.$i18n,"enable-video-sign-language":_vm.$store.state._core.user.accessibility.signLanguageEnabled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }